import { loadTossPayments, ANONYMOUS } from "@tosspayments/tosspayments-sdk";

const toss_client_key = process.env.VUE_APP_TOSS_WIDGET_CLIENT_KEY;
const tossPayments = await loadTossPayments(toss_client_key);

export { tossPayments, ANONYMOUS };
